import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";
import { requireExhaustive } from "../../shared/src/util";
import { TUserCaseUserType } from "../codecs/UserCaseUserType";

export const OnboardingRoleAudience = union([
    literal("driver"),
    literal("representative"),
    literal("giftor"),
    literal("beneficiary"),
]);
export type TOnboardingRoleAudienceCodec = typeof OnboardingRoleAudience;
export type TOnboardingRoleAudience = TTypeOfCodec<TOnboardingRoleAudienceCodec>;

export const deriveOnboardingRoleAudience = (userType: TUserCaseUserType): TOnboardingRoleAudience | null => {
    switch (userType) {
        case "client":
            return "driver";
        case "executor":
        case "personal_representative":
        case "company_executor":
        case "lpa":
            return "representative";
        case "giftor":
            return "giftor";
        case "beneficiary_receiving_payment":
            return "beneficiary";
        case "unknown":
        case "authorised_third_party":
        case "registered_third_party":
        case "deceased":
        case "beneficiary_not_receiving_payment":
        case "introducer":
        case "buyer":
        case "occupant":
        case "keyholder":
            return null;
        default:
            return requireExhaustive(userType);
    }
};
